import { FC, memo } from 'react';
import { useCreateProjectMutation } from 'store/features/project/project-api';
import { Loader } from 'components/common/Loader/Loader';
import { useQueryError } from 'lib/hooks/useQueryError';
import { useTranslation } from 'react-i18next';
import { ProjectForm, ProjectFormSubmitData } from '../ProjectForm/ProjectForm';
import { ErrorModal } from 'components/common/ErrorModal/ErrorModal';

type NewProjectProps = {
  onClose: () => void;
};

export const NewProject: FC<NewProjectProps> = memo(({ onClose }) => {
  const { t } = useTranslation();

  const [
    createProject,
    { isLoading: isCreateLoading, isError: isCreateError, error: createError },
  ] = useCreateProjectMutation();

  const { showError, closeError, errorMessage } = useQueryError(
    isCreateError,
    createError,
  );

  const handleCreate = async ({
    name,
    instruction,
    newFiles,
  }: ProjectFormSubmitData) => {
    await createProject({
      name,
      instruction,
      files: newFiles,
    }).unwrap();

    onClose();
  };

  return (
    <>
      <ProjectForm
        title={t('project.new')}
        onSubmit={handleCreate}
        textSubmit={t('project.create')}
        onClose={onClose}
      />
      {isCreateLoading && <Loader />}
      {showError && <ErrorModal message={errorMessage} onClose={closeError} />}
    </>
  );
});

NewProject.displayName = 'NewProject';
